import styled from "styled-components";

export const Container = styled.div`
  background-color: var(--main-bg);
  height: 100%;
`;
